import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from "axios";
import {
  Box,
  Button,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Slide,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Snackbar,
  Alert,
  InputAdornment
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PaymentsIcon from "@mui/icons-material/Payments";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { quantum, trio } from "ldrs";
import { useNavigate } from "react-router-dom";
import { Notyf } from 'notyf';
import SearchIcon from '@mui/icons-material/Search';
import PrintIcon from '@mui/icons-material/Print';


const notyf = new Notyf({
  position: { x: 'left', y: 'bottom' },
  duration: 3000,
});


quantum.register();
trio.register();

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MakePayment = ({ expenses, totalAmount }) => {
  const [open, setOpen] = useState(false);
  const [token, setToken] = useState(() => localStorage.getItem("token") || null);
  const [paymentAmount, setPaymentAmount] = useState("");
  const [memo, setPaymentMemo] = useState("");
  const [paymentId, setPaymentId] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [user, setUser] = useState({});
  const [editOpen, setEditOpen] = useState(false);
  const [editPayment, setEditPayment] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');




    const filteredPayments = useMemo(() => {
    if ( !payments) return [];

    return payments
        .filter(payment => {
            const matchesExpenseId = payment.expenses_id === expenses.id;
            if (!matchesExpenseId) return false;

            const matchesSearchQuery = searchQuery
                ? payment.pay_id.toLowerCase().includes(searchQuery.toLowerCase())
                : true;

            return matchesSearchQuery;
        })
        .sort((a, b) => {
            const dateA = new Date(a.date);
            const dateB = new Date(b.date);

            if (dateA.getTime() !== dateB.getTime()) {
                return dateB.getTime() - dateA.getTime();
            }

            return b.id - a.id; 
        });

}, [payments, searchQuery, expenses.id]);


  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/");
        return;
      }
      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          navigate("/");
        }
      }
    };

    fetchProfile();
  }, [navigate]);

  useEffect(() => {
    if (user.id) {
      fetchPayments();
    }
  }, [user.id]);

  useEffect(() => {
    if (expenses) {
      setPaymentId(expenses.id.toString());
      fetchPayments();
    }
  }, [expenses]);

  const handleSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleEditOpen = (payment) => {
    setEditPayment(payment);
    setEditOpen(true);
  };

  const handleEditClose = () => {
    setEditOpen(false);
  };

  const itemCategories = expenses?.items?.map(item => item.category) || [];

  const handleEditSave = async () => {
    setLoading(true);

    try {
      const paymentData = {
        payment_id: editPayment.payment_id,
        amount: editPayment.amount,
        date: editPayment.date,
        memo: editPayment.memo,
      };

      await axios.put(`https://admin.bizstor.lk/public/api/update-expensespayment/${editPayment.id}`, paymentData);

      fetchPayments();
      //setAlertOpen(true);
      //handleSnackbar("Payment updated successfully!", "success");
      handleEditClose();
      notyf.success('Payment updated successfull!');
    } catch (error) {
      //console.error("Error updating payment:", error);
      //handleSnackbar("Error updating payment!", "error");
      notyf.error('Error updating payment!');

    } finally {
      setLoading(false);
    }
  };

  const handleEditAmountChange = (event) => {
    setEditPayment({ ...editPayment, amount: event.target.value });
  };

  const handleEditMemoChange = (event) => {
    setEditPayment({ ...editPayment, memo: event.target.value });
  };

  const handleEditDateChange = (event) => {
    setEditPayment({ ...editPayment, date: event.target.value });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePay = async () => {
    setLoading(true);

    try {
      const paymentData = {
        usertoken: String(user.id),
        expenses_id: paymentId,
        amount: paymentAmount,
        memo: memo,
        name: expenses.fullname,
        item: itemCategories.join(', '),
        pay_id: `EPY-${Date.now()}`,
        date: paymentDate || new Date().toISOString().split("T")[0],
        email: expenses.email || null,
        totalAmount: totalAmount,
      };

      await axios.post("https://admin.bizstor.lk/public/api/expensespayment", paymentData);

      setPaymentAmount("");
      setPaymentDate("");
      setPaymentMemo("");
      notyf.success('Payment successfull!');
      fetchPayments();
    } catch (error) {
      //console.error("Error processing payment:", error.response ? error.response.data : error);
      //error.response.data.message : error.message), "error");
      notyf.error('Error processing payment!');

    } finally {
      setLoading(false);
    }
  };

  const handlePayAndClose = async () => {
    setLoading(true);

    try {
      const paymentData = {
        usertoken: String(user.id),
        expenses_id: paymentId,
        amount: paymentAmount,
        memo: memo,
        name: expenses.fullname,
        item: itemCategories.join(', '),
        pay_id: `EPY-${Date.now()}`,
        date: paymentDate || new Date().toISOString().split("T")[0],
        email: expenses.email || null, 
        totalAmount: totalAmount,
      };

      await axios.post("https://admin.bizstor.lk/public/api/expensespayment", paymentData);

      setPaymentAmount("");
      setPaymentDate("");
      setPaymentMemo("");
      fetchPayments();
      notyf.success('Payment successfull!');
      handleClose();
    } catch (error) {
      //console.error("Error processing payment:", error);
      notyf.error('Error processing payment!');
    } finally {
      setLoading(false);
    }
  };

  const handlePayAndPrint = async () => {
    if (!paymentAmount || Number(paymentAmount) <= 0) {
      notyf.error('Please enter a valid payment amount.');
      return;
    }

    setLoading(true);

    try {
      const paymentData = {
        usertoken: String(user.id),
        expenses_id: paymentId,
        amount: paymentAmount,
        memo: memo,
        name: expenses.fullname,
        item: itemCategories.join(', '),
        pay_id: `EPY-${Date.now()}`,
        date: paymentDate || new Date().toISOString().split("T")[0],
        email: expenses.email || null, 
        totalAmount: totalAmount,
      };

      await axios.post("https://admin.bizstor.lk/public/api/expensespayment", paymentData);

      const previousPaymentsTotal = calculateTotalPayments();
      const currentPaymentAmount = Number(paymentAmount);
      const totalPaidAfterThisPayment = previousPaymentsTotal + currentPaymentAmount;
      const dueAmountAfterThisPayment = totalAmount - totalPaidAfterThisPayment;

      const receiptDetails = {
        expenseId: expenses.id,
        payId: paymentData.pay_id,
        date: paymentData.date,
        totalAmount: totalAmount,
        previousPayments: previousPaymentsTotal,
        currentPayment: currentPaymentAmount,
        totalPaid: totalPaidAfterThisPayment,
        dueAmount: dueAmountAfterThisPayment,
      };

      printExpenseReceipt(receiptDetails);

      setPaymentAmount("");
      setPaymentDate("");
      setPaymentMemo("");
      notyf.success('Payment successful!');
      fetchPayments();

    } catch (error) {
      notyf.error('Error processing payment!');
    } finally {
      setLoading(false);
    }
  };

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://admin.bizstor.lk/public/api/get-expensespayment");
      if (user.id) {
        const filteredPayments = response.data.filter(
          (expensespayment) =>
            expensespayment.usertoken &&
            expensespayment.usertoken.toLowerCase() === user.id.toString().toLowerCase()
        );
        setPayments(filteredPayments);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const deletePayment = async (paymentId) => {
    setLoading(true);

    try {
      await axios.delete(`https://admin.bizstor.lk/public/api/delete-expensespayment/${paymentId}`);
      //handleSnackbar("Payment deleted successfully!", "success");
      notyf.success('Payment deleted successfull!');
      // Fetch updated payments
      fetchPayments();
      setAlertOpen(true);
    } catch (error) {
      //console.error("Error deleting payment:", error);
      //handleSnackbar("Error deleting payment!", "error");
      notyf.error('Error deleting payment!');

    } finally {
      setLoading(false);
    }
  };

  const calculateTotalAmount = () => {
    return expenses ? Number(expenses.amount) : 0;
  };

  const handleAmountChange = (event) => {
    setPaymentAmount(event.target.value);
  };

  const handleMemoChange = (event) => {
    setPaymentMemo(event.target.value);
  };

  const handleDateChange = (event) => {
    setPaymentDate(event.target.value);
  };

  const calculateTotalPayments = () => {
    let total = 0;
    payments.forEach((payment) => {
      if (expenses && expenses.id === payment.expenses_id) {
        total += Number(payment.amount);
      }
    });
    return total;
  };
  const totalPaid = calculateTotalPayments();
  const getPaymentStatus = () => {

    if (totalPaid >= totalAmount) {
      return totalPaid === totalAmount ? "Paid" : "Paid";
    }
    return "Pending";
  };


  if (!expenses) return null;

  const paymentStatus = getPaymentStatus();
  const dueAmount = calculateTotalAmount() - calculateTotalPayments();

const printExpenseReceipt = (receiptDetails) => {
  const {
    expenseId,
    payId,
    date,
    totalAmount,
    previousPayments,
    currentPayment,
    totalPaid,
    dueAmount,
  } = receiptDetails;

  const printWindow = window.open('', '_blank');
  const printContent = `
  <html>
    <head><title>Payment Receipt - #${expenseId}</title></head>
    <body style="font-family: Arial, sans-serif; margin: 20px;">
      <div style="max-width: 400px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 8px;">

        <!-- Logo and Company -->
        <div style="text-align: center; margin-bottom: 10px;">
          <img src=${`https://admin.bizstor.lk/storage/app/public/images/${user.image}`} alt="Logo" style="max-width: 100px; max-height: 100px; object-fit: contain;" />
          <div style="margin-top: 5px; font-weight: bold; color: #333; text-transform: uppercase;"><h2>${user.companyname ? user.companyname : ''}</h2></div>
        </div>

        <h4 style="text-align: center; color: #333;">Payment Receipt</h4>
        <p><strong>Receipt No:</strong> ${payId}</p>
        <p><strong>Date:</strong> ${new Date(date).toLocaleDateString()}</p>
        <hr/>
        <table style="width: 100%; margin-top: 15px; border-spacing: 0 8px;">
          <tr>
            <td>Total Amount:</td>
            <td style="text-align: right;">LKR ${Number(totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          </tr>
          <tr>
            <td>Previous Payments:</td>
            <td style="text-align: right;">LKR ${Number(previousPayments).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          </tr>
          <tr style="font-weight: bold;">
            <td>This Payment:</td>
            <td style="text-align: right;">LKR ${Number(currentPayment).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
          </tr>
        </table>
        <hr/>
        <div style="text-align: right; margin-top: 20px;">
          <p style="margin: 0; font-weight: bold;">Total Paid: LKR ${Number(totalPaid).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
          <p style="font-size: 1.2em; font-weight: bold; color: #d32f2f; margin-top: 5px;">
            Due Amount: LKR ${Number(dueAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
          </p>
        </div>
      </div>
    </body>
  </html>`;

  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => printWindow.print(), 1000);
};

  const totalFilteredAmount = filteredPayments.reduce(
    (sum, payment) => sum + parseFloat(payment.amount || 0),
    0
  );


const handlePrintFromHistory = (paymentToPrint) => {

    const paymentToPrintDate = new Date(paymentToPrint.date);

    const previousPaymentsTotal = payments
      .filter(p => {
        if (p.expenses_id !== expenses.id) {
          return false;
        }

        const pDate = new Date(p.date);

        if (pDate.getTime() < paymentToPrintDate.getTime()) {
          return true;
        }

        if (pDate.getTime() === paymentToPrintDate.getTime()) {
          return p.id < paymentToPrint.id;
        }

        return false;
      })
      .reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

    const currentPaymentAmount = parseFloat(paymentToPrint.amount || 0);

    const totalPaidAtTheTime = previousPaymentsTotal + currentPaymentAmount;

    const dueAmountAtTheTime = totalAmount - totalPaidAtTheTime; 

    const receiptDetails = {
      expenseId: expenses.id,
      payId: paymentToPrint.pay_id,
      date: paymentToPrint.date,
      totalAmount: totalAmount, 
      previousPayments: previousPaymentsTotal,
      currentPayment: currentPaymentAmount,
      totalPaid: totalPaidAtTheTime,
      dueAmount: dueAmountAtTheTime,
    };

    printExpenseReceipt(receiptDetails);
  };



  return (
    <React.Fragment>
      <Box>
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
          <Button
            variant="outlined"
            onClick={handleClickOpen}
            style={{ backgroundColor: "black", color: "white" }}
          >
            Make Payment
            <PaymentsIcon sx={{ marginLeft: "10px" }} />
          </Button>
        </Box>
        <Dialog
          fullScreen
          open={open}
          onClose={handleClose}
          TransitionComponent={Transition}
        >
          <AppBar sx={{ position: 'fixed', bgcolor: '#FAFAFA', boxShadow: 'none' }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseIcon sx={{ color: "red" }} />
              </IconButton>
              <Typography
                sx={{ ml: 2, flex: 1, color: "black", fontWeight: 'bold' }}
                variant="h6"
                component="div"
              >
                Make Payment
              </Typography>
            </Toolbar>
          </AppBar>
          <Box sx={{ p: 3, mt: 8 }}>
            <Box>
              <Typography
                sx={{
                  mb: 2,
                  fontSize: "25px",
                  fontWeight: "bold",
                  "@media (max-width: 600px)": {
                    fontSize: "20px",
                    fontWeight: "bold",
                    mb: 4,
                  },
                }}
              >
                Payment for Expense No: {expenses.id} <br /> Status : {paymentStatus} 
              </Typography>
              <p><strong>Total Amount :</strong> LKR.{Number(totalAmount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
              <p><strong>Total Payments :</strong> LKR.{calculateTotalPayments().toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  marginTop: "10px",
                  textAlign: "right",
                }}
              >
                <Typography variant="subtitle1">Due Amount</Typography>
                <Typography variant="h4" fontWeight="bold" sx={{ mb: 2 }}>
                  LKR. {(totalAmount - calculateTotalPayments()).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                Make Payment
              </Typography>
              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Memo</TableCell>
                      <TableCell align="left">Amount</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell align="left">
                        <TextField
                          type="date"
                          value={paymentDate || new Date().toISOString().split("T")[0]}
                          size="small"
                          onChange={handleDateChange}
                          sx={{
                            width: "100%",
                            "@media (max-width: 600px)": {
                              width: "90%",
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          type="text"
                          value={memo}
                          size="small"
                          onChange={handleMemoChange}
                          sx={{
                            width: '100%',
                            '@media (max-width: 600px)': {
                              width: '90%',
                            },
                          }}
                        />
                      </TableCell>
                      <TableCell align="left">
                        <TextField
                          type="number"
                          value={paymentAmount}
                          size="small"
                          onChange={handleAmountChange}
                          onWheel={(e) => e.preventDefault()}
                          onKeyDown={(e) => {

                            if (e.key === "ArrowUp" || e.key === "ArrowDown") {
                              e.preventDefault();
                            }
                          }}
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                          }}
                          sx={{
                            width: "100%",
                            "@media (max-width: 600px)": {
                              width: "90%",
                            },
                          }}
                        />

                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <Box display="flex" mt={2} sx={{ flexDirection: { xs: 'column', sm: 'row' }, gap: 1, justifyContent: { xs: 'center', sm: 'flex-end' }, alignItems: 'center' }}>
                <Button
                  onClick={handlePay}
                  variant="contained" color="primary" sx={{ width: { sm: '100px', xs: '100%' } }}
                >
                  {loading ? (
                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "white",
                        zIndex: 9999,
                      }}
                    >
                      <l-trio size="50" speed="1.3" color="red"></l-trio>
                    </Box>
                  ) : (
                    "Pay"
                  )}
                </Button>

                <Button
                  onClick={handlePayAndPrint}
                  variant="contained" color="primary" sx={{ width: { sm: '150px', xs: '100%' } }}
                >
                  {loading ? (
                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "white",
                        zIndex: 9999,
                      }}
                    >
                      <l-trio size="50" speed="1.3" color="red"></l-trio>
                    </Box>
                  ) : (
                    "Pay & Print"
                  )}
                </Button>

                <Button
                  onClick={handlePayAndClose}
                  variant="contained"
                  color="error"
                  sx={{ width: { sm: '150px', xs: '100%' } }}
                >
                  {loading ? (
                    <Box
                      sx={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "white",
                        zIndex: 9999,
                      }}
                    >
                      <l-trio size="50" speed="1.3" color="red"></l-trio>
                    </Box>
                  ) : (
                    "Pay & Close"
                  )}
                </Button>
              </Box>
            </Box>

            <Box sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ mb: 2 }}>Payment History</Typography>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Search by EPY No"
                size='small'
                margin="normal"
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TableContainer>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">#</TableCell>
                      <TableCell align="left">Date</TableCell>
                      <TableCell align="left">Amount</TableCell>
                      <TableCell align="left">Memo</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredPayments.map((payment, index) => {
                      if (expenses.id === payment.expenses_id) {
                        return (
                          <TableRow key={payment.id}>
                            <TableCell align="left">{payment.pay_id}</TableCell>
                            <TableCell align="left">{payment.date}</TableCell>
                            <TableCell align="left">
                              LKR.{parseFloat(payment.amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            </TableCell>
                            <TableCell align="left">{payment.memo}</TableCell>
                            <TableCell align="right">
                              <IconButton onClick={() => handleEditOpen(payment)}>
                                <EditIcon
                                  sx={{
                                    "&:hover": {
                                      color: "blue",
                                    },
                                  }}
                                />
                              </IconButton>
                              <IconButton onClick={() => handlePrintFromHistory(payment)}>
                                <PrintIcon sx={{ "&:hover": { color: "green" } }} />
                              </IconButton>
                              <IconButton
                                aria-label="delete"
                                onClick={() => deletePayment(payment.id)}
                              >
                                {loading ? (
                                  <Box
                                    sx={{
                                      position: "fixed",
                                      top: 0,
                                      left: 0,
                                      width: "100vw",
                                      height: "100vh",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      bgcolor: "white",
                                      zIndex: 9999,
                                    }}
                                  >
                                    <l-trio size="50" speed="1.3" color="red"></l-trio>
                                  </Box>
                                ) : (
                                  <DeleteIcon
                                    sx={{
                                      "&:hover": {
                                        color: "red",
                                      },
                                    }}
                                  />
                                )}
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </TableBody>
                </Table>
              </TableContainer>

              <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              >
                <Alert
                  onClose={handleSnackbarClose}
                  severity={snackbarSeverity}
                  sx={{
                    width: "100%",
                  }}
                >
                  {snackbarMessage}
                </Alert>
              </Snackbar>
            </Box>
          </Box>
        </Dialog>


        <Snackbar
          open={alertOpen}
          autoHideDuration={6000}
          onClose={() => setAlertOpen(false)}
          message="Saved successfully!"
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        />
      </Box>

      <Dialog
        open={editOpen}
        onClose={handleEditClose}
        TransitionComponent={Transition}
        maxWidth="md"
        fullWidth
      >
        <AppBar sx={{ position: "relative", bgcolor: "black" }}>
          <Toolbar>
            <Typography
              sx={{ ml: 2, flex: 1, color: "white" }}
              variant="h6"
              component="div"
            >
              Edit Payment
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={handleEditClose}
              aria-label="close"
            >
              <CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "10px",
              textAlign: "right",
              gap: 1
            }}
          >
            <TextField
              label="Payment Amount"
              type="number"
              value={editPayment.amount}
              size="small"
              onChange={handleEditAmountChange}
              sx={{ marginBottom: "10px", width: "48%" }}
            />
            <TextField
              label="Memo"
              type="text"
              value={editPayment.memo}
              size="small"
              onChange={handleEditMemoChange}
              sx={{ marginBottom: "10px", width: "48%" }}
            />
            <TextField
              label="Payment Date"
              type="date"
              value={editPayment.date}
              size="small"
              onChange={handleEditDateChange}
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ marginBottom: "10px", width: "48%" }}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              justifyContent: "flex-end",
              marginTop: "10px",
              textAlign: "right",
            }}
          >
            <Button
              variant="contained"
              onClick={handleEditSave}
              sx={{
                backgroundColor: "black",
                color: "white",
                "&:hover": {
                  backgroundColor: "#343a40",
                },
                width: "200px",
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
        {loading && (
          <Box
            sx={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'white',
              zIndex: 1300,
              pointerEvents: 'auto'
            }}
          >
            <l-trio size="50" speed="1.3" color="red"></l-trio>
          </Box>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default MakePayment;